import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { MedicalConditionModalComponent } from './customer-condition-modal.component';
import { CustomerConditionComponent } from './customer-condition.component';
import { MedicalAlertModalComponent } from './customer-medical-modal.component';
import { CustomerMedicalPickComponent } from './customer-medical-pick.component';
import { CustomerMedicalComponent } from './customer-medical.component';

@NgModule({
    declarations: [
        CustomerConditionComponent,
        CustomerMedicalComponent,
        CustomerMedicalPickComponent,
        MedicalAlertModalComponent,
        MedicalConditionModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        MultiSelectModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerConditionComponent,
        CustomerMedicalComponent,
        CustomerMedicalPickComponent,
        MedicalAlertModalComponent,
        MedicalConditionModalComponent
    ]
})

export class CustomerMedicalModule {}
